import { render } from "./CcNodeConfig.vue?vue&type=template&id=c0feaeb4&scoped=true&ts=true"
import script from "./CcNodeConfig.vue?vue&type=script&lang=ts"
export * from "./CcNodeConfig.vue?vue&type=script&lang=ts"

import "./CcNodeConfig.vue?vue&type=style&index=0&id=c0feaeb4&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0feaeb4"]])

export default __exports__